import React, { useEffect, useState, useMemo } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme, Colors } from 'styles/theme';
import Flex from 'components/common/Flex';
import { ArrowLeftHomeSvg, ArrowRightHomeSvg } from 'assets/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCreative, Pagination, Navigation } from 'swiper';
import { useTranslation } from 'react-i18next';
import useDepsContainer from 'hooks/useDepsContainer';
import 'swiper/css';
import 'swiper/css/effect-creative';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/swiper-bundle.css';
import './FreelowSwiper.css';

const IntroSwiper = () => {
  const styles = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const { uiStore } = useDepsContainer();
  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  const CARD_LIST = [
    {
      title: cachedT('forMatchmakers'),
      img: (
        <Flex>
          <img src="/images/home-freelows-1.webp" width={260} alt="" />
        </Flex>
      ),
      text: <p>{cachedT('friendIntroductions')}</p>
    },
    {
      title: cachedT('forLadiesAndGentlemen'),
      img: (
        <Flex>
          <img src="/images/home-freelows-2.webp" width={260} alt="" />
        </Flex>
      ),
      text: (
        <ul>
          <li>{cachedT('exclusiveSecretContent')}</li>
          <li>{cachedT('earnPumpkinFavorites')}</li>
          <li>{cachedT('instantFavoriteResponse')}</li>
          <li>{cachedT('giftSendingOptions')}</li>
        </ul>
      )
    },
    {
      title: cachedT('forEveryone'),
      img: (
        <Flex>
          <img src="/images/home-freelows-3.webp" width={260} alt="" />
        </Flex>
      ),
      text: <p>{cachedT('reputationVoting')}</p>
    }
  ];

  const handleParentClick = event => {
    event.stopPropagation();
  };

  const handlePrevClick = event => {
    event.stopPropagation();
  };

  const imgClick = event => {
    event.stopPropagation();
  };

  const Card = ({ item }) => {
    return (
      <Flex className={styles.card} height={'auto'} center mt={7} column style={{ position: 'relative' }}>
        <Flex center height={'100%'} justifyContent={'center'} column>
          <Flex
            style={{ textAlign: 'center' }}
            color={'#18181B'}
            bgcolor={'white'}
            fontSize={24}
            lineHeight={'32px'}
            fontWeight={700}
            margin={'40px auto 16px'}
          >
            {item.title}
          </Flex>
        </Flex>
        <Flex style={{ margin: '0 auto' }}>{item.img}</Flex>
        <div className={styles.overlay}></div>
        <div
          style={{
            position: 'absolute',
            fontWeight: '300',
            lineHeight: '20px',
            fontSize: '14px',
            width: 'calc(100% - 32px)',
            left: '16px',
            bottom: '64px',
            color: '#FFF',
            textAlign: 'center'
          }}
        >
          {item.text}
        </div>
      </Flex>
    );
  };

  // const CardPagingTion = ({ index, className, otherName }) => {
  //   const item = CARD_PAGINATION[index];

  //   return `
  //           <div class="swiper-pagination-freelow-item ${otherName} ${className}">
  //               <div class="swiper-pagination-freelow-item-conts">${
  //                 item
  //               }</div>
  //           </div>
  //       `;
  // };

  return (
    <Flex className={styles.content} id={'privacy'} width={'100vw'}>
      <Swiper
        pagination={true}
        modules={[Pagination]}
        className={styles.swiperList}
        key={uiStore.language}
        slidesPerView={mdDown ? 1 : 2}
      >
        {CARD_LIST.map((item, index) => {
          return (
            <SwiperSlide className={mdDown ? styles.slide : styles.slideLg} key={index}>
              <Card item={item} />
            </SwiperSlide>
          );
        })}
        <div className="freelow-swiper-pagination-md" style={{ top: '1rem', bottom: 'auto' }}></div>
      </Swiper>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    content: {
      margin: '0 auto',
      background: '#FFF'
    },
    swiperList: {
      width: '100%',
      padding: '0 0',
      margin: '24px 0',
      overflow: 'visible',
      position: 'relative',

      '& .swiper-pagination': {
        '& .swiper-pagination-bullet': {
          background: '#6B6D7B'
        },

        '& .swiper-pagination-bullet-active': {
          background: '#E85130'
        }
      }
    },
    slide: {
      background: '#FFF !important',
      width: 'calc(100% - 76px) !important',
      height: '612px',
      borderRadius: '24px 24px 0px 0px',
      border: '14px solid #000',
      margin: '0 24px  !important',
      flexDirection: 'column',
      alignItems: 'flex-start !important',
      justifyContent: 'normal !important',
      position: 'relative'
    },
    slideLg: {
      background: '#FFF !important',
      width: 'calc(50% - 72px) !important',
      height: '612px',
      borderRadius: '24px 24px 0px 0px',
      border: '14px solid #000',
      margin: '0 24px  !important',
      flexDirection: 'column',
      alignItems: 'flex-start !important',
      justifyContent: 'normal !important',
      position: 'relative'
    },
    card: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      width: '100%',

      '& ul': {
        paddingLeft: '16px',
        textAlign: 'left'
      }
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 14.06%, rgba(15, 15, 15, 0.54) 47.4%, #1C1C1C 87.5%)',
      display: 'block'
    }
  })
);

export default observer(IntroSwiper);
